import { ReactComponent as BlogIcon } from "../../../../assets/icons/financialPromotions/Blog.svg";
import { ReactComponent as SocialMediaPostIcon } from "../../../../assets/icons/financialPromotions/SocialMedia.svg";
import { ReactComponent as WebsiteIcon } from "../../../../assets/icons/financialPromotions/website.svg";
import { ReactComponent as NewsLetterIcon } from "../../../../assets/icons/financialPromotions/newsletter.svg";
import dayjs from "dayjs";

const formatDate = (ts) => {
  const d = ts?.toDate ? ts.toDate() : ts ? new Date(ts) : null;
  return d ? dayjs(d).format("D MMM YYYY") : "N/A";
};

const getContentIcon = (contentType) => {
  const t = String(contentType || "").toLowerCase();
  if (t.includes("blog")) return <BlogIcon />;
  if (t.includes("social")) return <SocialMediaPostIcon />;
  if (t.includes("website")) return <WebsiteIcon />;
  if (t.includes("newsletter")) return <NewsLetterIcon />;
  return <WebsiteIcon />;
};

const statusToChip = (status) => {
  // console.log("Mapping status:", status);
  const s = String(status || "").toLowerCase();

  // map your Firestore statuses to the screenshot labels
  if (["action_required", "referred", "needs_action"].includes(s))
    return { label: "Action Required", tone: "warn" };
  if (["awaiting_response", "awaiting", "awaiting_review"].includes(s))
    return { label: "Action Required", tone: "info" };
  if (["requested_changes", "awaiting", "awaiting_review"].includes(s))
    return { label: "Awaiting Response", tone: "info" };
  if (["processing", "in_progress", "in-progress", "pending"].includes(s))
    return { label: "Processing", tone: "info" };
  if (["approved", "completed"].includes(s))
    return { label: "Approved", tone: "ok" };
  if (["declined", "rejected", "failed"].includes(s))
    return { label: "Declined", tone: "bad" };

  return { label: status || "Unknown", tone: "neutral" };
};

const safeJson = (v) => {
  try {
    return JSON.stringify(v ?? {}, null, 2);
  } catch {
    return String(v);
  }
};

const getStatusColor = (status) => {
  switch ((status || "").toLowerCase()) {
    case "awaiting_review":
      return "#f59e0b";
    case "processing":
      return "#0ea5e9";
    case "completed":
      return "#16a34a";
    case "failed":
      return "#dc2626";
    default:
      return "#64748b";
  }
};

const Chip = ({ label, color = "#334155", bg = "#f1f5f9", className = "" }) => {
  if (!label) return null;
  return (
    <span
      className={`chip ${className}`}
      style={{ borderColor: `${color}33`, color, background: bg }}
    >
      {label}
    </span>
  );
};

function extractNameFromEmail(email) {
  if (!email) return "";
  const match = email.match(/^([a-zA-Z0-9._%+-]+)@/);
  if (!match) return email;
  // Replace dots/underscores with spaces, split, capitalize each part
  return match[1]
    .replace(/[._]/g, " ")
    .split(" ")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(" ");
}

export {
  formatDate,
  getContentIcon,
  statusToChip,
  safeJson,
  getStatusColor,
  Chip,
  extractNameFromEmail,
};
